import { Component, computed, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NotificationsService } from '../../services/notifications.service';
import { BreadcrumbsComponent } from '../breadcrumbs/breadcrumbs.component';
import { ProjectSelectorComponent } from '../project-selector/project-selector.component';
import { GlobalAssistDrawerService } from '../../services/global-assist-drawer.service';
import { WorkspaceFacade } from '@state';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    RouterModule,
    BreadcrumbsComponent,
    ProjectSelectorComponent
],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  private readonly notifications = inject(NotificationsService);
  private readonly store = inject(WorkspaceFacade);
  protected readonly globalAssist = inject(GlobalAssistDrawerService);

  readonly notificationCount = computed(() => this.notifications.unreadCount());

  readonly currentProjectName = computed((): string | null => {
    const selectedId = this.store.selectedProjectId();
    const projects = this.store.projects() ?? [];
    const selected =
      selectedId === null || selectedId === undefined
        ? null
        : (projects.find((p: any) => p.id === selectedId) ?? null);
    const name = String(selected?.name ?? '').trim();
    return name ? name : null;
  });
}
